import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from "../utils/storage";
import Login from '@/components/Login'
import MessageList from '@/components/infoData/MessageList'
import MessageDetail from '@/components/infoData/MessageDetail'
import MessageBackDetail from '@/components/infoData/MessageBackDetail'
import AppDownload from '@/components/other/AppDownload'
// import Home from '@/components/Home'
import KPIList from '@/components/kpi/KPIList'
import KPIDetail from '@/components/kpi/KPIDetail'
import ModernStack from '@/components/kpi/ModernStack'
import ModernAvgGoods from '@/components/kpi/ModernAvgGoods'
import ModernDay from '@/components/kpi/ModernDay'
import ModernPromotion from '@/components/kpi/ModernPromotion'
import ModernNew from '@/components/kpi/ModernNew'
import workdayconfig from '@/components/configCenter/workdayconfig'
import TwentyAvgGoods from '@/components/kpi/TwentyAvgGoods'
import TwentyBox from '@/components/kpi/TwentyBox'
import TwentyNew from '@/components/kpi/TwentyNew'

import MAAvgGoods from '@/components/kpi/MAAvgGoods'
import MABox from '@/components/kpi/MABox'
import MANew from '@/components/kpi/MANew'
import WorkLoad from '@/components/kpi/WorkLoad'
import ToTerminal from '@/components/kpi/ToTerminal'
import EightyAvgGoods from '@/components/kpi/EightyAvgGoods'
import EightyGoods from '@/components/kpi/EightyGoods'
import EightyBox from '@/components/kpi/EightyBox'
import Performance from '@/components/kpi/Performance'
import KpiHome from '@/components/kpi/KpiHome'
import CustomerKpi from '@/components/kpi/CustomerKpi'
import viewFile from '@/components/file/viewFile'
import vFile from '@/components/file/vFile'

import ReportHome from "@/components/report/ReportHome"; //h5
import TrainPeopleReport from "@/components/report/TrainPeopleReport";
import TrainBusinessReport from "@/components/report/TrainBusinessReport";
import TrainScoreReport from "@/components/report/TrainScoreReport";
import PassRate from "@/components/report/PassRate";
import workSummary from "@/components/report/workSummary";
import PassBusiness from "@/components/report/PassBusiness";
import navHome from "@/components/navHome";
import reportQualityScreen from "@/components/centeruser/reportQualityScreen";
import ViewPCenterDetail from "@/components/centeruser/ViewPCenterDetail";
import addDataBase from '@/components/info/addDataBase';

// import CenterSetUser from "@/components/centeruser/CenterSetUser"

// import Exam from '@/components/Exam'
// import InformationAblout from '@/components/mainData/InformationAblout'

Vue.use(Router)

var options = {
  base: '/web/',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: Home,
    //   show: false
    // },
    // {
    //   path: '/examManager',
    //   name: 'Exam',
    //   component: Exam,
    //   show: false
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      show: false
    },
    {
      path: '/messagelist/:uid',
      name: 'MessageList',
      component: MessageList,
      show: false
    },
    {
      path: '/messagedetil/:pid/:uid',
      name: 'MessageDetail',
      component: MessageDetail,
      show: false
    },
    {
      path: '/messagebackdetil/:callcardid/:uid/:msgid',
      name: 'MessageBackDetail',
      component: MessageBackDetail,
      show: false
    },
    {
      path: '/appdownload',
      name: 'AppDownload',
      component: AppDownload,
      show: false
    },
    {
      path: '/kpi/:uid',
      name: 'kpi',
      component: KPIList,
      show: false
    },
    {
      path: '/kpidetail/:type',
      name: 'kpidetail',
      component: KPIDetail,
      show: false
    },
    {
      path: '/ModernStack/:uid/:module/:title',
      name: 'ModernStack',
      component: ModernStack,
      show: false
    },
    {
      path: '/ModernAvgGoods/:uid/:module/:title',
      name: 'ModernAvgGoods',
      component: ModernAvgGoods,
      show: false
    },
    {
      path: '/ModernDay/:uid/:module/:title',
      name: 'ModernDay',
      component: ModernDay,
      show: false
    },
    {
      path: '/ModernPromotion/:uid/:module/:title',
      name: 'ModernPromotion',
      component: ModernPromotion,
      show: false
    },
    {
      path: '/ModernNew/:uid/:module/:title',
      name: 'ModernNew',
      component: ModernNew,
      show: false
    },
    {
      path: '/TwentyAvgGoods/:uid/:module/:title',
      name: 'TwentyAvgGoods',
      component: TwentyAvgGoods,
      show: false
    },
    {
      path: '/TwentyBox/:uid/:module/:title',
      name: 'TwentyBox',
      component: TwentyBox,
      show: false
    },
    {
      path: '/TwentyNew/:uid/:module/:title',
      name: 'TwentyNew',
      component: TwentyNew,
      show: false
    },
    {
      path: '/MAAvgGoods/:uid/:module/:title',
      name: 'MAAvgGoods',
      component: MAAvgGoods,
      show: false
    },
    {
      path: '/MABox/:uid/:module/:title',
      name: 'MABox',
      component: MABox,
      show: false
    },
    {
      path: '/MANew/:uid/:module/:title',
      name: 'MANew',
      component: MANew,
      show: false
    },
    {
      path: '/EightyAvgGoods/:uid/:module/:title',
      name: 'EightyAvgGoods',
      component: EightyAvgGoods,
      show: false
    },
    {
      path: '/EightyGoods/:uid/:module/:title',
      name: 'EightyGoods',
      component: EightyGoods,
      show: false
    },
    {
      path: '/EightyBox/:uid/:module/:title',
      name: 'EightyBox',
      component: EightyBox,
      show: false
    },
    {
      path: '/WorkLoad/:uid',
      name: 'WorkLoad',
      component: WorkLoad,
      show: false
    },
    {
      path: '/ToTerminal/:uid',
      name: 'ToTerminal',
      component: ToTerminal,
      show: false
    },
    {
      path: '/Performance/:uid',
      name: 'Performance',
      component: Performance,
      show: false
    },
    {
      path: '/kpihome/:uid/:role',
      name: 'KpiHome',
      component: KpiHome,
      show: false
    },
    {
      path: '/customerkpi/:cid',
      name: 'CustomerKpi',
      component: CustomerKpi,
      show: false
    },
    {
      path: '/viewFile',
      name: 'viewFile',
      component: viewFile,
      show: false
    },
    {
      path: '/vFile',
      name: 'vFile',
      component: vFile,
      show: false,
    },

    {
      path: '/ReportHome',
      name: 'ReportHome',
      component: ReportHome,
      show: false
    },

    {
      path: '/TrainPeopleReport',
      name: 'TrainPeopleReport',
      component: TrainPeopleReport,
      show: false
    },
    {
      path: '/TrainBusinessReport',
      name: 'TrainBusinessReport',
      component: TrainBusinessReport,
      show: false
    },
    {
      path: '/TrainScoreReport',
      name: 'TrainScoreReport',
      component: TrainScoreReport,
      show: false
    },
    {
      path: '/PassRate',
      name: 'PassRate',
      component: PassRate,
      show: false
    },
    {
      path: '/workSummary',
      name: 'workSummary',
      component: workSummary,
      show: false
    },
    {
      path: '/PassBusiness',
      name: 'PassBusiness',
      component: PassBusiness,
      show: false
    },
    {
      path: '/navHome',
      name: 'navHome',
      component: navHome,
      show: false
    },
    {
      path: '/reportQualityScreen',
      name: 'reportQualityScreen',
      component: reportQualityScreen,
      show: false
    },
    {
      path: '/ViewPCenterDetail',
      name: 'ViewPCenterDetail',
      component: ViewPCenterDetail,
      show: false
    },
     {
      path: '/addDataBase',
      name: 'addDataBase',
      component: addDataBase,
      show: false
    },
    // {
    //   path: '/InformationAblout',
    //   name: 'InformationAblout',
    //   component: InformationAblout,
    //   show: false
    // },

    // {
    //   path:'/CenterSetUser',
    //   name: 'CenterSetUser',
    //   component: CenterSetUser,
    //   show: false
    // },
  ]
};
var ms = store.getMenus();
for (var m in ms) {
  options.routes.push(ms[m]);
}
var router = new Router(options);
NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();

  var loginMenu = store.getCurMenu();
  if (!loginMenu && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})
router.afterEach(transition => {
  NProgress.done();
});
// 避免重复点击相同路由造成的报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
//————————————重复点击结束
export default router



// WEBPACK FOOTER //
// ./src/router/index.js